import { render, staticRenderFns } from "./TaskHome.vue?vue&type=template&id=61ee83f6&scoped=true"
import script from "./TaskHome.vue?vue&type=script&lang=js"
export * from "./TaskHome.vue?vue&type=script&lang=js"
import style0 from "./TaskHome.vue?vue&type=style&index=0&id=61ee83f6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ee83f6",
  null
  
)

export default component.exports